$(function() {
  let searchTimeout;
  const $search = $('#searchSales');
  const $inputId = $('#salesPersonId');
  const prefixedParamId = $search.data('saleid-param-id');
  const tadd = $search.data('t-add');
  const tremove = $search.data('t-remove');
  const tdelete = $search.data('t-delete');
  const notResultsFound = $search.data('t-not');

  $($search).on('keyup', function() {
    clearTimeout(searchTimeout);
    const query = $(this).val().trim();
    const url = $(this).data('search-url');
    const paramId = $(this).data('param-id');
    const resultsContainer = $('#searchResults');
    if (query.length < 2) {
      resultsContainer.hide().empty();
      return;
    }
    searchTimeout = setTimeout(function() {
      const data = { query: query };
      if (paramId) data[paramId] = query;

      $.nette.ajax({
        url: url,
        type: 'GET',
        data: data,
        beforeSend: function() {
          resultsContainer.html('<div class="list-group-item text-muted"><i class="fa fa-spinner fa-spin me-1"></i> Loading...</div>').show();
        },
        success: function(payload) {
          console.log(payload);
          if (payload.sales && payload.sales.length > 0) {
            let html = '';
            payload.sales.forEach(function(sale) {
              html += `
                <div id="list-sale-assign-${sale.id}" class="list-group-item list-group-item-action cursor-pointer">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="me-2">
                      <strong>#${sale.id}</strong> - <small class="name-short">${sale.name || 'N/A'}</small>
                    </div>
                    <a href="javascript:void(0);" class="assign-sale btn btn-sm btn-success" 
                       data-sale-id="${sale.id}"
                       data-sale-info='${JSON.stringify(sale)}'>
                      <i class="fa fa-plus-circle"></i> ${tadd}
                    </a>
                  </div>
                </div>
              `;
            });
            resultsContainer.html(html).show();
          } else {
            resultsContainer.html('<div class="list-group-item text-muted">'+notResultsFound+'</div>').show();
          }
        }
      });
    }, 300);
  });

  $(document).on('click', '.assign-sale', function(e) {
    e.stopPropagation();
    const saleId = $(this).data('sale-id');
    const saleInfo = $(this).data('sale-info');
    const data = { saleId: saleId };
    if (prefixedParamId) data[prefixedParamId] = saleId;
    $(this).prop('disabled', true);
    $("#searchPanel").addClass("hidden");
    $("#list-sale-assign-"+saleId).remove();
    $inputId.val(saleId);
    const $newItem = $(createSaleListItem(saleInfo));
    $('.list-sales').prepend($newItem);
  });

  $(document).on('click', '.remove-sale', function(e) {
    e.stopPropagation();
    const saleId = $(this).data('sale-id');
    const saleName = $(this).data('sale-name');
    const data = { saleId: saleId };
    if (prefixedParamId) data[prefixedParamId] = saleId;
    if (confirm(tremove.replace(/%item%/g, '#'+saleId+' '+saleName))) {
      $("#searchPanel").removeClass("hidden");
      const $item = $("#list-sale-" + saleId);
      $inputId.val('');
      $item.find('.remove-sale').prop('disabled', true);
      $item.remove();
    }
  });

  $(document).on('click', '#searchSales', function() {
    $search.trigger('keyup');
  });

  $(document).on('click', function(event) {
    const $target = $(event.target);
    if (!$target.closest('#searchSales').length && !$target.closest('#searchResults').length) {
      $('#searchResults').hide();
    }
  });


  function createSaleListItem(sale) {
    return `
    <div id="list-sale-${sale.id}" class="list-group-item d-flex list-group-item-action cursor-pointer justify-content-between align-items-center py-2 px-3">
      <div class="flex-grow-1 me-2">
        <div class="fw-semibold text-dark">
          <a href="${sale.editUrl}" title="Upravit data" target="_blank"><strong>#${sale.id}</strong> ${sale.name}</a>
        </div>
      </div>
      <div class="ms-2 flex-shrink-0">
        <button type="button" class="btn btn-sm text-danger remove-sale" data-sale-id="${sale.id}" data-sale-name="${sale.name}" title="${tdelete}">
          <i class="fa fa-trash-alt fa-fw"></i> ${tdelete}
        </button>
      </div>
    </div>
  `;
  }
});


